<template>
  <v-container>
    <v-row align="center" justify="center">
      <v-col justify="center" lg="6">
        <h2>How to contribute and query?</h2>
        <p></p>
        <h3>How to contribute data?</h3>
        <p></p>
        <p>
          The data needs to be sent either to the regional data steward or
          directly to one or the other APD chair in LiPD format. There are two
          ways to contribute data: either by filling in the excel template, or
          by entering the data and meta data directly via the web interface. The
          pdf file of the publication(s) concerned must be attached.
        </p>
        <p></p>
        <h3>How to query the APD?</h3>
        <p></p>
        <p>
          Once the data has been validated by the council and entered in LiPD
          format (taxonomy, age models), it can be accessed either directly from
          the APD web site, or from the multiproxy database of the IPSL, or from
          Neotoma.
        </p>

        <p>
          Data can be extracted in different formats, depending on the case
          (excel, text, tilia).
        </p>

        <p>APD offers two tools: 
          <ul>
          <li>a data library where each file can be downloaded separately</li>
          <li>a database allowing to associate several sites, to specify the taxon(s) and the period of interest. </li>
          </ul>
          </p>

        <p>Comparisons with other kind of data are possible via the IPSL and Neotoma database</p></v-col
      ></v-row
    >
  </v-container>
</template>

<script>
export default {};
</script>

<style>
a:link {
  color: #2b2118;
}
a:visited {
  color: #2b2118;
}
</style>